import Vue from 'vue';
import LottieAnimation from 'lottie-web-vue'
import Donut from 'vue-css-donut-chart';
import VueMask from 'v-mask';
import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import enUS from '@kangc/v-md-editor/lib/lang/en-US';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'vue-css-donut-chart/dist/vcdonut.css';
import httpRequester from './plugins/httpRequester';

VMdEditor.lang.use('en-US', enUS);
VMdEditor.use(githubTheme);

Vue.use(Donut);
Vue.config.productionTip = false;
Vue.use(httpRequester);
Vue.use(VueMask)
Vue.use(LottieAnimation)
Vue.use(VMdEditor);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
